import { useContext, useEffect, useState } from 'react'
import styles from './loginPage.module.css'
import DisplayLoginContext from '../../context/displayLogin'
import ArrowIcon from '../../assets/svg/arrowIcon'
import logo from '../../assets/img/logo.png'
import Login from './login/login'
import Register from './register/register'
import PasswordForgotten from './passwordForgotten/passwordForgotten'
import ImageBackground2 from '../../assets/svg/ImageBackground2'
import ImageBackground3 from '../../assets/svg/imageBackground3'
import PasswordForgottenIcon from '../../assets/svg/passwordForgottenIcon'

function LoginPage(props)
{
    const displayLoginContext = useContext(DisplayLoginContext)

    const [loading,setLoading] = useState(false)

    let touchStart = 0

    const touchStartFunc = (e) =>
    {
        touchStart = e.touches[0].clientY
    }

    const touchEnd = (e) =>
    {
        const end = e.changedTouches[0].clientY
        if(Math.abs(end - touchStart) > window.innerHeight*0.4 && (end-touchStart) < 0)
        {
            displayLoginContext.setDisplayLogin('')
        }
    }

    useEffect(()=>{
        if(displayLoginContext.displayLogin === 'login')
        {
            document.title = 'Logowanie'
        }
        else if(displayLoginContext.displayLogin === 'register')
        {
            document.title = `Rejestracja`
        }
        else if(displayLoginContext.displayLogin === 'passwordForgotten')
        {
            document.title = `Odzyskiwanie konta`
        }
        else
        {
            document.title = 'Strona Główna'
        }
    },[displayLoginContext.displayLogin])

    return(
        <article onTouchStart={touchStartFunc} onTouchEnd={touchEnd} className={`${styles.container} ${displayLoginContext.displayLogin?styles.displayContainer:''}`}>
            <div className={`${styles.back} ${loading?styles.backWhileLoading:''}`} onClick={e=>!loading && displayLoginContext.setDisplayLogin('')}>
                <ArrowIcon class={styles.backSVG}/>
            </div>

            <img src={logo} className={styles.logo}/>

            <ImageBackground3 class={`${styles.backgroundSVG} ${displayLoginContext.displayLogin === 'register'?styles.svgDisplay:''}`}/>
            <ImageBackground2 class={`${styles.backgroundSVG} ${displayLoginContext.displayLogin === "login"?styles.svgDisplay:''}`}/>
            <PasswordForgottenIcon class={`${styles.backgroundSVG} ${displayLoginContext.displayLogin === 'passwordForgotten'?styles.svgDisplay:''}`}/>

            <Login loading={loading} setLoading={setLoading} display={displayLoginContext.displayLogin === "login"} />
            <Register loading={loading} setLoading={setLoading} display={displayLoginContext.displayLogin === "register"} />
            <PasswordForgotten loading={loading} setLoading={setLoading} display={displayLoginContext.displayLogin === 'passwordForgotten'} />

        </article>
    )
}

export default LoginPage